var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("Field")]),_c('ESFieldTreeselect',{attrs:{"value":_vm.value.field,"mappingPropsTree":_vm.mappingPropsTree},on:{"input":_vm.onFieldChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }